import React from 'react';
import PropTypes from 'prop-types';
import AuthButton from '../AuthButton';

const SocialButtonsPane = ({
  onClickGithubProvider,
  onClickGoogleProvider,
  onClickMicrosoftProvider
}) =>
  <div className="button-wrapper">
    <AuthButton strategy="github" label="Sign up with Github" onClick={onClickGithubProvider} />
    <AuthButton strategy="google" label="Sign up with Google" onClick={onClickGoogleProvider} />
    <AuthButton
      strategy="windowslive"
      label="Sign up with Microsoft"
      onClick={onClickMicrosoftProvider}
    />
  </div>;

SocialButtonsPane.propTypes = {
  onClickGithubProvider: PropTypes.func.isRequired,
  onClickGoogleProvider: PropTypes.func.isRequired,
  onClickMicrosoftProvider: PropTypes.func.isRequired
};

export default SocialButtonsPane;



// WEBPACK FOOTER //
// ./src/modules/signupForm/components/SocialButtonsPane/SocialButtonsPane.js